import React from 'react';
import { BarChart } from './BarChart/BarChart';
import { PieChart } from './PieChart/PieChart';
import { MapChart } from './MapChart/MapChart';

import './ChartBox.scss';

export const ChartBox = function({data}) {

	let chart = null;
	let adaText = '';

	console.log(data)
	switch (data.Type) {

		case "bar":
			chart = <BarChart data={data.Bar.Values}/>;
			let tempbar = '';
			data.Bar.Values.forEach((v, i, a) => tempbar += (v.Label + ": " + v.Value + (i == a.length -1 ? "+":"") + " schools "));
			adaText = 'Animated bar chart. ' + tempbar;
			break;

		case "pie":
			chart = <PieChart data={data.Pie.Values}/>;
			let temppie = '';
			data.Pie.Values.forEach(v => temppie += (v.Label + ": " + v.Value + "% "));

			adaText = 'Animated pie chart. ' + temppie;
			break;

		case "map":
			chart = <MapChart data={data.Map}/>;
			adaText = data.Map.AltText;
			break;
	}

	return (
		<div className="vbn-dg-table-cell--chart-box">
			<div className="vbn-dg-table-cell--chart-box-inner" aria-label={adaText} role="img">
				{chart}
			</div>
		</div>
	);
};